import { useEffect, useState } from 'react'

import { listAllYmOfferPricing } from '@/lib/api/client/ymarket-pricing'
import type { YmOfferPricing } from '@/lib/api/schemas/ymarket-pricing.schema'

export type SelectedYmOffers =
  | { kind: 'idle' }
  | { kind: 'loading' }
  | { kind: 'ready'; offers: YmOfferPricing[] }
  | { kind: 'failed'; message: string }

/** The published YM offers among the selected pieces; `null` ids means nothing to resolve. */
export function useSelectedYmOffers(productIds: readonly string[] | null): SelectedYmOffers {
  const [resolution, setResolution] = useState<SelectedYmOffers>({ kind: 'idle' })
  const key = productIds === null ? null : [...productIds].sort().join(',')

  useEffect(() => {
    if (key === null) {
      setResolution({ kind: 'idle' })
      return undefined
    }
    const wanted = new Set(key.split(','))
    const controller = new AbortController()
    setResolution({ kind: 'loading' })
    listAllYmOfferPricing(controller.signal)
      .then((offers) => {
        if (!controller.signal.aborted) setResolution({ kind: 'ready', offers: offers.filter((offer) => wanted.has(offer.productId)) })
      })
      .catch((cause: unknown) => {
        if (!controller.signal.aborted) setResolution({ kind: 'failed', message: cause instanceof Error && cause.message !== '' ? cause.message : 'Не удалось загрузить цены Маркета.' })
      })
    return () => controller.abort()
  }, [key])

  return resolution
}
